// Aura & Oak Living - Store-Wide Animation & Global Script
document.addEventListener('DOMContentLoaded', () => {
  if (window.lucide) {
    lucide.createIcons();
  }
  enhanceProductDescriptions();
  initMobileAutoCarousels();

  // Scroll Reveal Intersection Observer
  const revealElements = document.querySelectorAll('.reveal-on-scroll, section, .product-card');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          obs.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -50px 0px',
      threshold: 0.08
    });

    revealElements.forEach(el => {
      if (!el.classList.contains('no-reveal')) {
        el.classList.add('reveal-on-scroll');
        observer.observe(el);
      }
    });
  } else {
    revealElements.forEach(el => el.classList.add('is-revealed'));
  }

  // Mobile Menu Toggle
  const mobileMenuBtn = document.getElementById('mobileMenuBtn');
  const mobileMenu = document.getElementById('mobileMenu');
  if (mobileMenuBtn && mobileMenu) {
    mobileMenuBtn.addEventListener('click', () => {
      mobileMenu.classList.toggle('hidden');
    });
  }

  // Cart Drawer Toggle
  const cartToggleBtn = document.getElementById('cartToggleBtn');
  const cartDrawer = document.getElementById('cartDrawer');
  const closeCartBtn = document.getElementById('closeCartBtn');
  const cartOverlay = document.getElementById('cartOverlay');

  if (cartToggleBtn && cartDrawer) {
    cartToggleBtn.addEventListener('click', () => {
      cartDrawer.classList.remove('translate-x-full');
      if (cartOverlay) cartOverlay.classList.remove('hidden');
    });
  }

  if (closeCartBtn && cartDrawer) {
    closeCartBtn.addEventListener('click', () => {
      cartDrawer.classList.add('translate-x-full');
      if (cartOverlay) cartOverlay.classList.add('hidden');
    });
  }

  if (cartOverlay && cartDrawer) {
    cartOverlay.addEventListener('click', () => {
      cartDrawer.classList.add('translate-x-full');
      cartOverlay.classList.add('hidden');
    });
  }
});

// Toast notification helper
function showToast(message, type = 'success') {
  const toast = document.createElement('div');
  toast.className = `fixed bottom-6 right-6 z-50 px-5 py-3 rounded-2xl shadow-2xl text-xs font-semibold flex items-center gap-2 transform translate-y-10 opacity-0 transition-all duration-300 ${
    type === 'success' ? 'bg-brand-900 text-white' : 'bg-rose-900 text-white'
  }`;
  toast.innerHTML = `<i data-lucide="${type === 'success' ? 'check-circle' : 'alert-circle'}" class="w-4 h-4"></i> <span>${message}</span>`;
  document.body.appendChild(toast);
  if (window.lucide) lucide.createIcons();

  setTimeout(() => {
    toast.classList.remove('translate-y-10', 'opacity-0');
  }, 10);

  setTimeout(() => {
    toast.classList.add('translate-y-10', 'opacity-0');
    setTimeout(() => toast.remove(), 300);
  }, 3500);
}

// Global Wishlist Toggle
function toggleWishlist(productId) {
  let wishlist = JSON.parse(localStorage.getItem('ao_wishlist') || '[]');
  const idx = wishlist.indexOf(productId);
  if (idx > -1) {
    wishlist.splice(idx, 1);
    showToast('Removed from your saved pieces');
  } else {
    wishlist.push(productId);
    showToast('Added to your saved wishlist!');
  }
  localStorage.setItem('ao_wishlist', JSON.stringify(wishlist));
  const countBadge = document.getElementById('wishlistCount');
  if (countBadge) countBadge.innerText = wishlist.length;
}


// ==========================================
// AURA & OAK - PRODUCT DETAIL PAGE HELPERS
// ==========================================

let currentImageIdx = 0;
let autoSlideTimer = null;

function updateSlideCounter(idx, total) {
  const counter = document.getElementById('slideCounter');
  if (counter && total > 0) {
    counter.innerText = (idx + 1) + ' / ' + total;
  }
}

function setMainImage(src, idx) {
  const mainImg = document.getElementById('mainProductImg');
  if (mainImg) {
    mainImg.style.opacity = '0.7';
    setTimeout(() => {
      mainImg.src = src;
      mainImg.style.opacity = '1';
    }, 150);
  }
  currentImageIdx = idx;
  const thumbs = document.querySelectorAll('.thumb-item');
  updateSlideCounter(idx, thumbs.length);
  
  thumbs.forEach((el, i) => {
    if (i === idx) {
      el.classList.add('ring-2', 'ring-brand-900');
    } else {
      el.classList.remove('ring-2', 'ring-brand-900');
    }
  });

  const carousel = document.getElementById('thumbCarousel');
  if (carousel && thumbs[idx]) {
    const activeThumb = thumbs[idx];
    const scrollOffset = activeThumb.offsetLeft - (carousel.clientWidth / 2) + (activeThumb.clientWidth / 2);
    carousel.scrollTo({ left: scrollOffset, behavior: 'smooth' });
  }
}

function nextProductImage() {
  const thumbs = document.querySelectorAll('.thumb-item');
  if (thumbs.length <= 1) return;
  currentImageIdx = (currentImageIdx + 1) % thumbs.length;
  const nextSrc = thumbs[currentImageIdx].getAttribute('data-img-src');
  if (nextSrc) setMainImage(nextSrc, currentImageIdx);
}

function prevProductImage() {
  const thumbs = document.querySelectorAll('.thumb-item');
  if (thumbs.length <= 1) return;
  currentImageIdx = (currentImageIdx - 1 + thumbs.length) % thumbs.length;
  const prevSrc = thumbs[currentImageIdx].getAttribute('data-img-src');
  if (prevSrc) setMainImage(prevSrc, currentImageIdx);
}

function startAutoSlide() {
  const thumbs = document.querySelectorAll('.thumb-item');
  if (thumbs.length > 1 && !autoSlideTimer) {
    autoSlideTimer = setInterval(nextProductImage, 5000);
  }
}

function stopAutoSlide() {
  if (autoSlideTimer) {
    clearInterval(autoSlideTimer);
    autoSlideTimer = null;
  }
}

function switchProductTab(tabId, btn) {
  document.querySelectorAll('.pdp-tab-content').forEach(el => el.classList.add('hidden'));
  document.querySelectorAll('.pdp-tab').forEach(el => {
    el.classList.remove('active', 'border-brand-900', 'text-stone-900');
    el.classList.add('border-transparent', 'text-stone-400');
  });
  
  const target = document.getElementById(tabId);
  if (target) target.classList.remove('hidden');
  if (btn) {
    btn.classList.add('active', 'border-brand-900', 'text-stone-900');
    btn.classList.remove('border-transparent', 'text-stone-400');
  }
}

function changeBlueprintImage(src, btn) {
  const mainBlueprint = document.getElementById('blueprintMainImg');
  const lightboxImg = document.getElementById('lightboxBlueprintImg');
  if (mainBlueprint) mainBlueprint.src = src;
  if (lightboxImg) lightboxImg.src = src;
  
  document.querySelectorAll('.blueprint-thumb').forEach(b => {
    b.classList.remove('ring-2', 'ring-brand-900', 'border-transparent');
  });
  if (btn) btn.classList.add('ring-2', 'ring-brand-900', 'border-transparent');
}

function openBlueprintModal() {
  const modal = document.getElementById('blueprintLightboxModal');
  if (modal) {
    modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }
}

function closeBlueprintModal() {
  const modal = document.getElementById('blueprintLightboxModal');
  if (modal) {
    modal.classList.add('hidden');
    document.body.style.overflow = '';
  }
}

function openDimensionBlueprintTab() {
  const specsBtn = document.querySelector('button[onclick*="tab-specs"]');
  if (specsBtn) {
    switchProductTab('tab-specs', specsBtn);
    const target = document.getElementById('tab-specs');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}

function triggerDirectCheckout() {
  const form = document.getElementById('product_form');
  if (form) {
    const checkoutInput = document.createElement('input');
    checkoutInput.type = 'hidden';
    checkoutInput.name = 'return_to';
    checkoutInput.value = '/checkout';
    form.appendChild(checkoutInput);
    form.submit();
  }
}

function handleOptionSelection(optionIndex, value) {
  const label = document.getElementById('option-label-' + optionIndex);
  if (label) label.innerText = value;

  const buttons = document.querySelectorAll('.option-pill-' + optionIndex);
  buttons.forEach(btn => {
    const btnVal = btn.getAttribute('data-value');
    if (btnVal === value || (btnVal && btnVal.toLowerCase() === value.toLowerCase())) {
      btn.classList.add('is-active');
      btn.classList.remove('bg-white', 'text-stone-700', 'text-stone-800', 'border-stone-300');
      btn.classList.add('bg-stone-900', 'text-white', 'border-stone-900');
      btn.style.backgroundColor = '#18181b';
      btn.style.color = '#ffffff';
      btn.style.borderColor = '#18181b';
    } else {
      btn.classList.remove('is-active');
      btn.classList.remove('bg-stone-900', 'bg-brand-900', 'text-white', 'border-stone-900', 'border-brand-900');
      btn.classList.add('bg-white', 'text-stone-800', 'border-stone-300');
      btn.style.backgroundColor = '#ffffff';
      btn.style.color = '#1e293b';
      btn.style.borderColor = '#cbd5e1';
    }
  });

  const variantsData = document.getElementById('product-variants-json');
  if (variantsData) {
    try {
      const variants = JSON.parse(variantsData.textContent);
      const selectedOptions = [];
      const optionLabels = document.querySelectorAll('[id^="option-label-"]');
      optionLabels.forEach(el => selectedOptions.push(el.innerText.trim()));

      const matchedVariant = variants.find(v => {
        return selectedOptions.every((optVal, idx) => v.options[idx] === optVal || (v.options[idx] && v.options[idx].toLowerCase() === optVal.toLowerCase()));
      });

      if (matchedVariant) {
        const idInput = document.getElementById('selectedVariantId');
        if (idInput) idInput.value = matchedVariant.id;

        const priceEl = document.getElementById('productPrice');
        if (priceEl && window.Shopify && Shopify.formatMoney) {
          priceEl.innerHTML = Shopify.formatMoney(matchedVariant.price);
        }

        if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
          setMainImage(matchedVariant.featured_image.src, 0);
        }
      }
    } catch(e) {}
  }
}

function submitCustomerReview(form) {
  const author = document.getElementById('reviewAuthor').value;
  const title = document.getElementById('reviewTitle').value || 'Verified Review';
  const body = document.getElementById('reviewBody').value;
  
  const reviewsList = document.getElementById('reviewsList');
  if (reviewsList) {
    const newCard = document.createElement('div');
    newCard.className = 'bg-white p-6 rounded-2xl border border-stone-200 shadow-sm space-y-2';
    newCard.innerHTML = `
      <div class="flex justify-between items-start">
        <div class="flex items-center gap-2">
          <div class="w-8 h-8 rounded-full bg-stone-200 text-stone-900 font-bold text-xs flex items-center justify-center">
            ${author.slice(0, 2).toUpperCase()}
          </div>
          <div>
            <h4 class="font-semibold text-xs text-stone-900">${author}</h4>
            <span class="text-[10px] text-emerald-700 font-semibold">Verified Customer &bull; Just now</span>
          </div>
        </div>
        <div class="flex text-amber-400">
          <i data-lucide="star" class="w-3.5 h-3.5 fill-amber-400"></i>
          <i data-lucide="star" class="w-3.5 h-3.5 fill-amber-400"></i>
          <i data-lucide="star" class="w-3.5 h-3.5 fill-amber-400"></i>
          <i data-lucide="star" class="w-3.5 h-3.5 fill-amber-400"></i>
          <i data-lucide="star" class="w-3.5 h-3.5 fill-amber-400"></i>
        </div>
      </div>
      <h5 class="font-bold text-xs text-stone-900 pt-1">${title}</h5>
      <p class="text-xs text-stone-600 leading-relaxed">${body}</p>
    `;
    reviewsList.prepend(newCard);
    form.reset();
    document.getElementById('writeReviewBox').classList.add('hidden');
    if (window.lucide) lucide.createIcons();
    if (typeof showToast === 'function') {
      showToast('Thank you! Your review has been submitted.', 'success');
    }
  }
}
// =========================================================
// INTELLIGENT LUXURY PRODUCT DESCRIPTION ENHANCER
// =========================================================
function enhanceProductDescriptions() {
  const suites = document.querySelectorAll('.product-description-suite');
  suites.forEach(suite => {
    // 1. Transform Bullet Points / List Items into Compact Clean Chips (No duplicate dots)
    const listItems = suite.querySelectorAll('li');
    listItems.forEach(li => {
      if (li.querySelector('.desc-chip-content')) return;

      let rawText = li.textContent.trim();
      // Remove any leading bullet symbols or dots if already present in text
      rawText = rawText.replace(/^[\sâ€¢\-\*â€“â€”]+\s*/, '');
      const lower = rawText.toLowerCase();

      // Categorize chip accents
      if (lower.includes('surcharge') || rawText.includes('Â£40') || rawText.includes('Â£50')) {
        li.classList.add('chip-surcharge');
      } else if (lower.includes('free delivery') || lower.includes('warranty') || lower.includes('guarantee')) {
        li.classList.add('chip-trust');
      } else if (lower.includes('damage') || lower.includes('non-refundable') || lower.includes('important') || lower.includes('attention') || lower.includes('no delivery')) {
        li.classList.add('chip-warning');
      }

      // Detect Key-Value Delimiter
      let delimiter = null;
      if (rawText.includes(' - ')) delimiter = ' - ';
      else if (rawText.includes(' â€” ')) delimiter = ' â€” ';
      else if (rawText.includes(': ')) delimiter = ': ';

      if (delimiter) {
        const parts = rawText.split(delimiter);
        const key = parts[0].trim();
        const val = parts.slice(1).join(delimiter).trim();

        if (key && val && key.length < 50) {
          li.innerHTML = `
            <div class="desc-chip-content flex flex-col">
              <span class="desc-key-title font-bold text-stone-900 leading-tight">${key}</span>
              <span class="desc-val-desc text-stone-600 leading-tight">${val}</span>
            </div>
          `;
          return;
        }
      }

      li.innerHTML = `
        <div class="desc-chip-content">
          <span class="desc-val-desc text-stone-800 font-semibold leading-tight">
            ${rawText}
          </span>
        </div>
      `;
    });

    // 2. Transform Headings into Compact Luxury Section Title Bars with Icons
    const headings = suite.querySelectorAll('h1, h2, h3, h4, h5, p > strong:only-child');
    headings.forEach(h => {
      if (h.classList.contains('desc-heading-enhanced')) return;
      h.classList.add('desc-heading-enhanced');
      const text = h.textContent.trim().toUpperCase().replace(/[:\s]+$/, '');
      let icon = 'sparkles';
      let themeClass = 'from-amber-50 border-amber-500 text-stone-900';

      if (text.includes('SPECIFICATION') || text.includes('DIMENSION') || text.includes('SIZE') || text.includes('DETAIL')) {
        icon = 'sliders';
        themeClass = 'from-stone-100 border-stone-800 text-stone-900';
      } else if (text.includes('DELIVERY') || text.includes('SHIPPING') || text.includes('SURCHARGE')) {
        icon = 'truck';
        themeClass = 'from-amber-50 border-amber-600 text-stone-900';
      } else if (text.includes('EXTRA') || text.includes('OPTIONAL') || text.includes('ADD-ON')) {
        icon = 'plus-circle';
        themeClass = 'from-stone-50 border-stone-600 text-stone-900';
      } else if (text.includes('NOTE') || text.includes('IMPORTANT') || text.includes('ATTENTION') || text.includes('WARNING')) {
        icon = 'alert-triangle';
        themeClass = 'from-rose-50 border-rose-500 text-rose-950';
      }

      const wrapper = document.createElement('div');
      wrapper.className = `desc-section-header bg-gradient-to-r ${themeClass} to-transparent px-2.5 py-1.5 rounded-lg border-l-4 font-bold text-xs tracking-wider flex items-center gap-1.5 mb-2 mt-3 shadow-2xs`;
      wrapper.innerHTML = `<i data-lucide="${icon}" class="w-3.5 h-3.5 flex-shrink-0"></i> <span>${text}</span>`;
      
      if (h.tagName.toLowerCase() === 'strong' && h.parentElement && h.parentElement.tagName.toLowerCase() === 'p') {
        h.parentElement.replaceWith(wrapper);
      } else {
        h.replaceWith(wrapper);
      }
    });
  });

  if (window.lucide) {
    lucide.createIcons();
  }
}

// =========================================================
function enhanceProductDescriptions() {
  const suites = document.querySelectorAll('.product-description-suite');
  suites.forEach(suite => {
    // 1. Transform Bullet Points / List Items into High-Converting Highlight Chips
    const listItems = suite.querySelectorAll('li');
    listItems.forEach(li => {
      if (li.querySelector('.desc-chip-content')) return;

      const rawText = li.textContent.trim();
      const lower = rawText.toLowerCase();

      // Categorize chip accents
      if (lower.includes('surcharge') || rawText.includes('Â£40') || rawText.includes('Â£50')) {
        li.classList.add('chip-surcharge');
      } else if (lower.includes('free delivery') || lower.includes('warranty') || lower.includes('guarantee')) {
        li.classList.add('chip-trust');
      } else if (lower.includes('damage') || lower.includes('non-refundable') || lower.includes('important') || lower.includes('attention')) {
        li.classList.add('chip-warning');
      }

      // Detect Key-Value Delimiter
      let delimiter = null;
      if (rawText.includes(' - ')) delimiter = ' - ';
      else if (rawText.includes(' â€” ')) delimiter = ' â€” ';
      else if (rawText.includes(': ')) delimiter = ': ';

      if (delimiter) {
        const parts = rawText.split(delimiter);
        const key = parts[0].trim();
        const val = parts.slice(1).join(delimiter).trim();

        if (key && val && key.length < 55) {
          li.innerHTML = `
            <div class="desc-chip-content flex flex-col gap-0.5">
              <span class="desc-key-title font-bold text-stone-950 text-xs sm:text-[13px] tracking-tight flex items-center gap-1.5">
                <span class="desc-dot w-1.5 h-1.5 rounded-full bg-amber-500 inline-block flex-shrink-0"></span>
                ${key}
              </span>
              <span class="desc-val-desc text-[11px] sm:text-xs text-stone-600 leading-snug font-normal">
                ${val}
              </span>
            </div>
          `;
          return;
        }
      }

      li.innerHTML = `
        <div class="desc-chip-content">
          <span class="desc-val-desc text-xs text-stone-800 font-semibold leading-snug">
            ${rawText}
          </span>
        </div>
      `;
    });

    // 2. Transform Headings into Luxury Section Title Bars with Icons
    const headings = suite.querySelectorAll('h1, h2, h3, h4, h5, p > strong:only-child');
    headings.forEach(h => {
      if (h.classList.contains('desc-heading-enhanced')) return;
      h.classList.add('desc-heading-enhanced');
      const text = h.textContent.trim().toUpperCase();
      let icon = 'sparkles';
      let themeClass = 'from-amber-50 border-amber-500 text-stone-900';

      if (text.includes('SPECIFICATION') || text.includes('DIMENSION') || text.includes('SIZE')) {
        icon = 'sliders';
        themeClass = 'from-stone-100 border-stone-800 text-stone-900';
      } else if (text.includes('DELIVERY') || text.includes('SHIPPING') || text.includes('SURCHARGE')) {
        icon = 'truck';
        themeClass = 'from-amber-50 border-amber-600 text-stone-900';
      } else if (text.includes('EXTRA') || text.includes('OPTIONAL') || text.includes('ADD-ON')) {
        icon = 'plus-circle';
        themeClass = 'from-stone-50 border-stone-600 text-stone-900';
      } else if (text.includes('NOTE') || text.includes('IMPORTANT') || text.includes('ATTENTION') || text.includes('WARNING')) {
        icon = 'alert-triangle';
        themeClass = 'from-rose-50 border-rose-500 text-rose-950';
      }

      const wrapper = document.createElement('div');
      wrapper.className = `desc-section-header bg-gradient-to-r ${themeClass} to-transparent px-3 py-2 rounded-xl border-l-4 font-bold text-xs sm:text-sm tracking-wider flex items-center gap-2 mb-3 mt-5 shadow-2xs`;
      wrapper.innerHTML = `<i data-lucide="${icon}" class="w-4 h-4 flex-shrink-0"></i> <span>${text}</span>`;
      
      if (h.tagName.toLowerCase() === 'strong' && h.parentElement && h.parentElement.tagName.toLowerCase() === 'p') {
        h.parentElement.replaceWith(wrapper);
      } else {
        h.replaceWith(wrapper);
      }
    });
  });

  if (window.lucide) {
    lucide.createIcons();
  }
}

// =========================================================
// UNIVERSAL 5-SECOND MOBILE AUTO-CAROUSEL ENGINE
// =========================================================
function initMobileAutoCarousels() {
  const isMobile = () => window.innerWidth < 768;

  const carousels = document.querySelectorAll('.auto-mobile-carousel, #catalogGrid');

  carousels.forEach(carousel => {
    if (!carousel) return;

    if (carousel._autoSlideTimer) {
      clearInterval(carousel._autoSlideTimer);
    }

    let isUserInteracting = false;
    let resumeTimeout = null;

    carousel.addEventListener('touchstart', () => {
      isUserInteracting = true;
      if (resumeTimeout) clearTimeout(resumeTimeout);
    }, { passive: true });

    carousel.addEventListener('touchend', () => {
      resumeTimeout = setTimeout(() => {
        isUserInteracting = false;
      }, 2500);
    }, { passive: true });

    carousel.addEventListener('mouseenter', () => {
      isUserInteracting = true;
    });

    carousel.addEventListener('mouseleave', () => {
      isUserInteracting = false;
    });

    carousel._autoSlideTimer = setInterval(() => {
      if (!isMobile() || isUserInteracting) return;

      const cards = Array.from(carousel.children).filter(c => {
        return c.style.display !== 'none' && !c.classList.contains('hidden') && c.offsetWidth > 0;
      });

      if (cards.length <= 1) return;

      const currentScroll = carousel.scrollLeft;
      const maxScroll = carousel.scrollWidth - carousel.clientWidth;

      if (currentScroll >= maxScroll - 25) {
        carousel.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        const nextCard = cards.find(card => card.offsetLeft > currentScroll + 20);
        if (nextCard) {
          carousel.scrollTo({ left: nextCard.offsetLeft - carousel.offsetLeft, behavior: 'smooth' });
        } else {
          const step = cards[0].offsetWidth + 16;
          carousel.scrollTo({ left: currentScroll + step, behavior: 'smooth' });
        }
      }
    }, 5000);
  });
}
window.addEventListener('resize', initMobileAutoCarousels);


